Vue.component('contenttab', {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div class="contentTab-container" v-if="componentReady">
                
                <div class="contentTab">

                    <div @click="close" class="contentTab__close">
                        <img src="assets/img/ui/close-icon.svg" />
                    </div>

                    <contenttab-nav 
                        :navItems="navItems"
                        @select="select"
                        :currentId="currentNav.id"
                    />

                    <div v-if="current" class="contentTab-body">
                        <!-- TEMPLATE TYPE A (full 16x9 media area) -->
                        <contenttab-16x9
                            v-if="current.templateType === '16x9'"
                            :title="current.title"
                            :subtitle="current.subtitle" 
                            :text="current.text"
                            :mediaContent="current.tabMedia[0]"
                        />
                        <!-- TEMPLATE TYPE B (two even columns rectangle media area: kinda strange format) -->
                        <contenttab-1x1
                            v-else-if="current.templateType === '1x1'"
                            :title="current.title"
                            :subtitle="current.subtitle" 
                            :text="current.text"
                            :mediaContent="current.tabMedia[0]"
                        />
                        <!-- TEMPLATE TYPE C (9x16 mobile format) -->
                        <contenttab-9x16 
                            v-else-if="current.templateType === '9x16'"
                            :title="current.title"
                            :subtitle="current.subtitle" 
                            :text="current.text"
                            :mediaContent="current.tabMedia[0]"
                        />
                    </div>
                </div>

                <img class="contentTab-bg" v-if="bgSrc" :src="bgSrc" />

            </div>
        </transition>
    `,
    data () {
        return {
            componentReady: false,
            background: null,
            bgSrc: null,
            tabs: [],
            current: null,
            currentNav: {}
        }
    },
    computed: {
        navItems () {
            const navItems = []
            for (let i = 0; i < this.tabs.length; i++)
            {
                navItems.push({
                    title: this.tabs[i].title,
                    id: i
                })
            }

            return navItems
        }
    },
    created () {
        if (this.background)
        {
            this.bgSrc = config.BACKGROUND_IMAGE_DIRECTORY + this.background.src
        }
        this.current = this.tabs[0]
        if (this.current)
        {
            this.select({ title: this.current.title, id: 0 })
        }
    },
    mounted () {
        this.componentReady = true
    },
    methods: {
        close () {
            const currentRoute = this.$router.currentRoute.path
            const noContentRoute = currentRoute.split(':')
            this.$router.push(noContentRoute[0])
        },
        select (item) {
            const id = item.id
            const title = item.title

            if (this.tabs[id] && this.tabs[id].title === title)
            {
                this.current = this.tabs[id]
                this.currentNav = item
            }
        }
    }
})

touchKit.ComponentManager.register('contenttab', {
    singleton: true
});

// navigation left and right
// based on variable length nav items. But also shows part of the next items.
// Calculates whats fully visible and moves next item into view. 
// Alot of offsetWidth calculations. Kinda complicated component.
Vue.component('contenttab-nav', {
    props: ['navItems', 'currentId'],
    template: `
        <div class="contentTab__tabs">
            <div 
                v-show="hasLeftTabs"
                @click="goLeft"
                class="contentTab__tabs__arrow contentTab__tabs__arrow--left">
            </div>
            <div class="contentTab__tabs__container" :style="{ left: offset + 'px' }" ref="container">
                <div
                    v-for="navItem in navItems"
                    :class="{ 'contentTab__tabs__tab--current': navItem.id === currentId }"
                    @click="$emit('select', navItem)"
                    class="contentTab__tabs__tab">
                    {{ navItem.title }}
                </div>
            </div>
            <div
                v-show="hasRightTabs"
                @click="goRight"
                class="contentTab__tabs__arrow contentTab__tabs__arrow--right">
            </div>
            <div v-if="debug" class="contentTab__tabs__debug">
                <p>offset: {{ offset }} </p>
                <p>hasLeftTabs: {{ hasLeftTabs }} </p>
                <p>hasRightTabs: {{ hasRightTabs }} </p>
                <p>alignedTo: {{ alignedTo }} </p>
                <p>leftVisibleItemIndex: {{ leftVisibleItemIndex }} </p>
                <p>rightVisibleItemIndex: {{ rightVisibleItemIndex }} </p>
            </div>
        </div>
    `,
    data () {
        return {
            debug: false,
            offset: 0,

            // default
            rightVisibleItemIndex: 0, // the last tab that is fully visible on each side.
            leftVisibleItemIndex: 0,
            alignedTo: 'left', // what side has a tab that is directly up against the side. 
        }
    },
    computed: {
        containerWidth () {
            return 1325 - 50 //the margin-left
        },
        hasRightTabs () {
            if (this.navItems.length === 0)
            {
                return false
            }
            else
            {
                return this.rightVisibleItemIndex + 1 !== this.navItems.length
            }
        },
        hasLeftTabs () {
            return this.offset < 0
        }
    },
    mounted () {
        this.updateRightVisible()
        console.log(this.hasRightTabs)
        console.log(this.rightVisibleItemIndex + 1, this.navItems.length)
    },
    methods: {
        goRight () {
            let length = 0
            const tabEls = this.$refs.container.children
            this.rightVisibleItemIndex += 1

            if (this.alignedTo === 'right')
            {
                console.log('TODO: right aligned')
                //TODO: minus next
                length = tabEls[this.rightVisibleItemIndex].offsetWidth * -1
            }
            else if (this.alignedTo === 'left')
            {
                let visibleWidth = 0
                let i = this.leftVisibleItemIndex
                
                for (i; i < tabEls.length; i++)
                {
                    if (i < this.rightVisibleItemIndex)
                    {
                        visibleWidth += tabEls[i].offsetWidth
                    }
                }
    
                
                length = (this.containerWidth - visibleWidth) - tabEls[this.rightVisibleItemIndex].offsetWidth
            }

            this.alignedTo = 'right'
            this.updateLeftVisible()
            this.offset += length
        },
        goLeft () {
            const tabEls = this.$refs.container.children
            let visibleWidth = 0
            let length = 0
            if (this.alignedTo === 'right')
            {
                let i = this.rightVisibleItemIndex

                for (i; i >= 0; i--)
                {
                    visibleWidth += tabEls[i].offsetWidth
    
                    if (visibleWidth > this.containerWidth)
                    {
                        visibleWidth -= tabEls[i].offsetWidth
                        break
                    }
                }
                length = tabEls[this.leftVisibleItemIndex-1].offsetWidth - (this.containerWidth - visibleWidth)
            }
            else if (this.alignedTo === 'left')
            {
                length = tabEls[this.leftVisibleItemIndex-1].offsetWidth;
            }
            
            this.leftVisibleItemIndex -= 1

            this.alignedTo = 'left'
            this.updateRightVisible()
            this.offset += length
        },
        updateLeftVisible () {
            if (this.alignedTo === 'right')
            {
                const tabEls = this.$refs.container.children
                let i = this.rightVisibleItemIndex
                let lengthCalc = 0
                for (i; i >= 0; i--)
                {
                    lengthCalc += tabEls[i].offsetWidth
                    if (lengthCalc >= this.containerWidth)
                    {
                        this.leftVisibleItemIndex = i + 1
                        break
                    }
                }
            }
        },
        updateRightVisible () {
            if (this.alignedTo === 'left')
            {
                const tabEls = this.$refs.container.children
                let i = this.leftVisibleItemIndex
                let visibleWidth = 0
                for (i; i < tabEls.length; i++)
                {
                    visibleWidth += tabEls[i].offsetWidth

                    if (visibleWidth >= this.containerWidth)
                    {
                        this.rightVisibleItemIndex = i - 1
                        break
                    }
                }
            }
        }
    }
})

Vue.component('contenttab-16x9', {
    props: ['title', 'subtitle', 'text', 'mediaContent'],
    template: `
        <div class="contentTab__a">
            <h1 class="contentTab__header">{{ title }}</h1>
            <div class="contentTab__a__center">
                <contenttab-media
                    class="contentTab__a__center__video" 
                    :video="mediaContent.video"
                    :poster="mediaContent.poster"
                    :image="mediaContent.image"
                />
                <h3 class="contentTab__subtitle">{{ subtitle }}</h3>
                <p class="contentTab__a__center__text">{{ text }}</p>
            </div>
        </div>
    `
})

Vue.component('contenttab-1x1', {
    props: ['title', 'subtitle', 'text', 'mediaContent'],
    template: `
        <div class="contentTab__b">
            <div class="contentTab__b__left">
                <h1 class="contentTab__header">{{ title }}</h1>
                <h3 class="contentTab__subtitle">{{ subtitle }}</h3>
                <div
                    v-if="text"
                    v-html="text"
                    class="contentTab__textarea">
                </div>
            </div>
            <div class="contentTab__b__right">
                <contenttab-media
                    class="contentTab__b__right__img" 
                    :video="mediaContent.video"
                    :poster="mediaContent.poster"
                    :image="mediaContent.image"
                />
            </div>
        </div>
    `
})

Vue.component('contenttab-9x16', {
    props: ['title', 'subtitle', 'text', 'mediaContent'],
    template: `
        <div class="contentTab__c">
            <div class="contentTab__c__left">
                <h1 class="contentTab__header">{{ title }}</h1>
                <h3 class="contentTab__subtitle">{{ subtitle }}</h3>
                <div v-if="text"
                    v-html="text"
                    class="contentTab__textarea">
                </div>
            </div>
            <div class="contentTab__c__right">
                <contenttab-media
                    class="contentTab__c__right__img" 
                    :video="mediaContent.video"
                    :poster="mediaContent.poster"
                    :image="mediaContent.image"
                />
            </div>
        </div>
    `
})

// can display image or video with poster.
Vue.component('contenttab-media', {
    props: ['video', 'poster', 'image'],
    template: `
        <div class="contenttab-media">
            <img v-if="imageSrc" class="contenttab-media__img" :src="imageSrc" draggable="false" />
            <div v-else class="contenttab-media__video">
                <img 
                    src="assets/img/ui/play-video.svg"
                    class="contenttab-media__video__icon"
                    draggable="false"
                    v-if="!isPlaying"
                />
                <img 
                    class="contenttab-media__video__poster"
                    v-show="!isPlaying"
                    @click="play"
                    :src="posterSrc"
                    draggable="false" />
                <video
                    v-show="isPlaying"
                    :src="videoSrc"
                    ref="video"
                    class="contenttab-media__video"
                    playsinline
                    controls>
                </video>
            </div>
        </div>
    `,
    data () {
        return {
            isVideo: null,
            isPlaying: false
        }
    },
    computed: {
        imageSrc () {
            if (this.image)
            {
                return config.BACKGROUND_IMAGE_DIRECTORY + this.image.src
            }
            else
            {
                return null
            }
        },
        videoSrc () {
            if (this.video)
            {
                return config.BACKGROUND_IMAGE_DIRECTORY + this.video.src
            }
            else
            {
                return null
            }
        },
        posterSrc () {
            if (this.poster)
            {
                return config.BACKGROUND_IMAGE_DIRECTORY + this.poster.src
            }
            else
            {
                return ''
            }
        }
    },
    created () {},
    methods: {
        play () {
            this.isPlaying = true
            this.$refs.video.play()
        }
    }
})